<div id="wrapper">
  <router-outlet *ngIf="themeService.themeLoaded"></router-outlet>
</div>